const STRIPE_URLS = {
  apple_pay_sessions: 'apple_pay/sessions',
  tokens: 'tokens'
}

export default (api) => ({
  apple_pay_init: (data) => api.post(STRIPE_URLS.apple_pay_sessions, data),
  tokens: (data) => api.post(STRIPE_URLS.tokens, data)
})
